var Hogan = require('hogan.js');

export const tooltipTemplate = Hogan.compile(`
<div class="map-tooltip">
  <div class="close">
      <i class="icon_close"></i>
  </div>
  <div class="tt-name">
      <% name %><%#noCount%>*<%/noCount%>
  </div>
  <div class="tt-pop">
      <strong><% formattedPop %></strong> Zugezogene
  </div>
</div>
`, {delimiters: '<% %>'});

export const resultTemplate = Hogan.compile(`
<div class="result" class="clearfix">
    <div class="close">
        <svg class="icon icon-close">
            <use xlink:href="spritemap.svg#icon-close"></use>
        </svg>
    </div>
<div class="result-body">
    <div class="result-country"><% country_de %></div>
    <div class="result-title"><% name %><span class="light"><%#noCount%>*<%/noCount%></span></div>
    <div class="result-distance">Distanz: <% formattedDist %> km</div>
    <div class="result-number-wrapper">
        <div class="result-number-label"><strong>Zugezogene</strong> (insgesamt)</div>
        <div class="result-number"><% formattedPop %></div>
    </div>
    <div class="result-appendix">Damit liegt <strong><% name %></strong> auf Platz <strong><% value_rang %></strong> der häufigsten Geburtsorte.</div></div>
</div>
</div>
`, {delimiters: '<% %>'});

export const tableTemplate = Hogan.compile(`
<div class="t-flex table-result table-dist">
  <div class="t-head">
    <div class="t-row">
      <div class="t-data t-data-1"><span class="t-head-label">Ort</span></div>
      <div class="t-data t-data-2 highlight"><span class="t-head-label">Zugezogene</span></div>
    </div>
  </div>
  <div class="t-body">
    <%#tabledata%>
    <div class="t-row">
      <div class="t-data t-data-1">
        <div class="rank">
          <%#isPop%>
            <% value_rang %>
          <%/isPop%>
          <%^isPop%>
            <% value2_rang %>
          <%/isPop%>
        </div>
        <div class="name"><% name %> <em>(<% country %>)</em></div>
      </div>
      <div class="t-data t-data-2 highlight">
        <div class="t-value"><% num %></div>
        <div class="t-chart bar-wrapper">
          <div class="bar" style="width:<% width %>%;"></div>
        </div>
      </div>
    </div>
    <%/tabledata%>
  </div>
</div>
`, {delimiters: '<% %>'});

export const tableTemplateDist = Hogan.compile(`
<div class="t-flex table-result table-dist">
  <div class="t-head">
    <div class="t-row">
      <div class="t-data t-data-1"><span class="t-head-label">Ort</span></div>
      <div class="t-data t-data-2 highlight"><span class="t-head-label">Entfernung</span></div>
      <div class="t-data t-data-3"><span class="t-head-label">Zugezog.</span></div>
    </div>
  </div>
  <div class="t-body">
    <%#tabledata%>
    <div class="t-row">
      <div class="t-data t-data-1">
        <div class="rank">
          <%#isPop%>
            <% value_rang %>
          <%/isPop%>
          <%^isPop%>
            <% value2_rang %>
          <%/isPop%>
        </div>
        <div class="name"><% name %> <em>(<% country %>)</em></div>
      </div>
      <div class="t-data t-data-2 highlight"><% num %> km</div>
      <div class="t-data t-data-3"><% pop %></div>
    </div>
    <%/tabledata%>
  </div>
</div>
`, {delimiters: '<% %>'});

export default {
  tooltipTemplate,
  resultTemplate,
  tableTemplatePop: tableTemplate,
  tableTemplateDistance: tableTemplateDist
};
